 import Modal from "react-bootstrap/Modal";
import notification from "../../icons/new_mail.png";
import "../../styles/modals.scss";
export default function SubAccountRequest(props) {

  return (
    <div className="sendpayment">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="d-flex justify-content-between align-items-center" closeButton>

        </Modal.Header>
        <Modal.Body className="modalContent">
          <center>
            <img src={notification} alt="" />
            <h3>Pending Request!</h3>
            <p>
              You have a pending invite <br /> Please check the inbox folder of
              your email to view details and accept or reject this request.
            </p>
          </center>
        </Modal.Body>
      </Modal>
    </div>
  );
}
